module.exports = __webpack_public_path__ + "img/facebook.f1249e72.svg";